export const changeNumbertoString = (value,digit) => {
  switch (digit) {
    case 1:
      return value.toString()
    case 2:
      return value<10? "0"+value.toString() : value.toString() 
    case 3:
      return value<10 ? "00"+value.toString() : value<100 ? "0"+value.toString() :  value.toString() 
    case 4:
      return value<10 ? "000"+value.toString() : value<100 ? "00"+ value.toString() : value<1000 ?  "0"+ value.toString()  : value.toString() 
    default:
      return value.toString()
  }
}

export const groupByKey = (list, key) => {
  return list.reduce((hash, obj) => {
    if (!obj) return hash;
    if((hash[obj[key]] || []).length === 0) {
      hash[obj[key]] = [obj] 
    } else {
      hash[obj[key]].push(obj)
    }
    return hash 
  }, {});
};

export const findPermutations = (value)=> {
  if (typeof value !== 'string') {
      return null
  }
  if (value.length < 2) {
      return [value]
  }
  const permutationsResult = []
  for (let index = 0; index < value.length; index++) {
      const char = value[index]
      if (value.indexOf(char) !== index) {
          continue
      }
      const remainingString = value.slice(0, index) + value.slice(index + 1, value.length)
      for (const permutation of findPermutations(remainingString)) {
          permutationsResult.push(char + permutation)
      }
  }
  return permutationsResult
}


export const formattedContent = (text) => {
  const urlPattern = /https?:\/\/[^\s<]+/g;

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = text;

  function processNode (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      // Replace URLs only in text nodes
      const parent = node.parentElement;
      if (urlPattern.test(node.textContent) && parent && parent.tagName !== "A") {
        const newHTML = node.textContent.replace(urlPattern, (url) => {
          return `<a href="${url}" target="_blank" style="color: rgb(0, 138, 0)">${url}</a>`;
        });
        const newNode = document.createElement("span");
        newNode.innerHTML = newHTML;
        parent.replaceChild(newNode, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "A") {
      // Recursively process child nodes, but ignore <a> elements
      for (let child of [...node.childNodes]) {
        processNode(child);
      }
    }
  }

  processNode(tempDiv);

  return tempDiv.innerHTML;
}